import {
  Flex,
  Box,
} from "@chakra-ui/react";
import GlobalSearchInput from "../GlobalSearchInput/GlobalSearchInput.tsx";
import UploadToaster from "../UploadToaster.tsx";
import UserAvatarMenu from "../UserAvatarMenu.tsx";

const GlobalHeader = () => {
  return (
    <Flex
      w="full"
      align="center"
      justify="space-between"
      py={4}
      mb={6}
    >
      <Flex align="center" gap={3} minW={0}>
        <Box minW="450px" maxW="550px" w="450px" flexShrink={0}>
          <GlobalSearchInput/>
        </Box>
        <UploadToaster/>
      </Flex>

      <Flex align="center" gap={4} flexShrink={0}>
        <UserAvatarMenu/>
      </Flex>
    </Flex>
  );
};

export default GlobalHeader;
